
import type { Result, ResultSort } from '@empathybroker/tsclient-play/dist/models/search/result'
import type { PropType } from 'vue'
import { ResultSortCriteriaIdEnum } from '@empathybroker/tsclient-play/dist/enums/search/debug/result/result-sort-criteria-id.enum'
import { defineComponent } from 'vue'

import { ColorEnum } from '../../enums'
import { NumberUtils } from '../../utils'

import { EpbBadge } from '../shared/epb-badge'
import ExplainResultsRow from './explain-results-row.component.vue'

export default defineComponent({
  name: 'ExplainResultsTiebreakersRow',
  components: {
    ExplainResultsRow,
    EpbBadge,
  },
  props: {
    results: {
      type: Array as PropType<Array<Result>>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      childrenExpanded: false,
      ColorEnum,
    }
  },
  computed: {
    resultIds(): string[] {
      return this.results.map((result: Result) => result.id)
    },
    tiebreakerIds(): string[] {
      return this.results.reduce((tiebreakersIds: string[], result: Result) => {
        const resultTiebreakers = this.getResultTiebreakers(result)
        resultTiebreakers.forEach((tiebreaker: ResultSort) => {
          if (!tiebreakersIds.includes(tiebreaker.id)) {
            tiebreakersIds.push(tiebreaker.id)
          }
        })
        return tiebreakersIds
      }, [])
    },
  },
  methods: {
    getResultTiebreakers(result: Result): ResultSort[] {
      return result.debug.sort.filter(
        (sortCriteria: ResultSort) => sortCriteria.id !== ResultSortCriteriaIdEnum.SCORE,
      )
    },
    getResultTiebreakerValueText(result: Result, tiebreakerId: string): string {
      const resultTiebreaker = this.getResultTiebreakers(result).find(
        (tiebreaker: ResultSort) => tiebreaker.id === tiebreakerId,
      )
      let valueText: string
      if (resultTiebreaker) {
        valueText = resultTiebreaker.value
        if (!isNaN(resultTiebreaker.value)) {
          valueText = NumberUtils.truncNumberWithoutRounding(Number(valueText)).toString()
        }
      }
      return valueText || '-'
    },
  },
})
